import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from '@maplecroft-typescript/utils';
import { TranslatePipe } from '@maplecroft-ui/translate';

@Pipe({
  name: 'score',
  pure: false,
})
export class ScorePipe extends TranslatePipe implements PipeTransform {
  public override transform(score: string | number | null | undefined): string | undefined {
    if (isNumber(score)) {
      return formatNumber(score, this.translateService.language(), '1.2-2');
    }

    setTimeout(() => this.params.set({ translationKey: 'common.no-score' }));

    return this.lastKnownTranslation();
  }
}
